import { render, staticRenderFns } from "./commissionPanel.vue?vue&type=template&id=73bcd27e&"
import script from "./commissionPanel.ts?vue&type=script&lang=ts&"
export * from "./commissionPanel.ts?vue&type=script&lang=ts&"
import style0 from "./commissionPanel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports